import { hooks, mui, React, ui } from '_core';

import { DraftParams, Params } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: Params) => void;
};
const Form = ({ params }: FormProps) => {
  const [window, setWindow] = React.useState(params.window);

  const uiStyles = hooks.useUiStyles();
  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Grid container spacing={4}>
        <mui.core.Grid size={{ xs: 12, md: 6 }}>
          <ui.NumericField
            textFieldProps={{
              label: 'Forward Window (days)',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              required: true,
            }}
            value={window}
            setValue={(v) => setWindow(v)}
          />
        </mui.core.Grid>
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default Form;
